<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <div class="iq-card mb-0" style="min-width: 300px;">
    <div class="iq-card-header d-flex justify-content-between">
      <div class="iq-header-title">
        <h4 class="card-title">Add New User</h4>
        <p class="mb-0 text-muted">Step {{ step }} of 3</p>
      </div>
    </div>
    <div class="iq-card-body">
      <div v-if="step === 1" class="row">
        <div role="group" class="form-group col-md-6">
          <label for="userId" class="d-block form-label text-left">
            Email:
          </label>
          <div class="bv-no-focus-ring">
            <div role="group" class="input-group">
              <input
                class="form-control"
                type="email"
                id="userId"
                placeholder="Email"
                v-model="data.userId"
                :class="errors.userId ? 'is-invalid' : ''"
              >
              <b-form-invalid-feedback v-if="errors.userId">
                {{ Object.values(errors.userId) }}
              </b-form-invalid-feedback>
            </div>
          </div>
        </div>
        <div role="group" class="form-group col-md-6">
          <label for="userStatus" class="d-block form-label text-left">
            Status:
          </label>
          <div class="bv-no-focus-ring">
            <div role="group" id="userStatus" class="input-group">
              <select
                class="form-control"
                v-model="data.userStatus"
                :disabled="isSubmit"
                :class="errors.userStatus ? 'is-invalid' : ''"
              >
                <option value="1" selected="selected">Approved</option>
                <option value="0">Not Approved</option>
              </select>
              <b-form-invalid-feedback v-if="errors.userStatus">
                {{ Object.values(errors.userStatus) }}
              </b-form-invalid-feedback>
            </div>
          </div>
        </div>
        <div role="group" class="form-group col-md-6">
          <label for="username" class="d-block form-label text-left">
            Username:
          </label>
          <div class="bv-no-focus-ring">
            <div role="group" class="input-group">
              <input
                class="form-control"
                type="text"
                id="username"
                placeholder="username"
                v-model="data.usloUserName"
                :class="errors.usloUserName ? 'is-invalid' : ''"
              >
              <b-form-invalid-feedback v-if="errors.usloUserName">
                {{ Object.values(errors.usloUserName) }}
              </b-form-invalid-feedback>
            </div>
          </div>
        </div>
        <div role="group" class="form-group col-md-6">
          <label for="usloPassword" class="d-block form-label text-left">
            password:
          </label>
          <div class="bv-no-focus-ring">
            <div role="group" class="input-group">
              <input
                class="form-control"
                type="password"
                id="usloPassword"
                placeholder="password"
                v-model="data.usloPassword"
                :class="errors.usloPassword ? 'is-invalid' : ''">
              <b-form-invalid-feedback v-if="errors.usloPassword">
                {{ Object.values(errors.usloPassword) }}
              </b-form-invalid-feedback>
            </div>
          </div>
        </div>
        <div role="group" class="form-group col-md-6">
          <label class="d-block form-label text-left">
            Company:
          </label>
          <input class="form-control" type="text" disabled :value="activeCompanyName">
        </div>
        <div role="group" class="form-group col-md-6">
          <label for="uscoAllAssets" class="d-block form-label text-left">
            Access To All Assets:
          </label>
          <select id="uscoAllAssets" class="form-control" v-model="data.uscoAllAssets" :disabled="isSubmit">
            <option value="0">No — select vessels manually</option>
            <option value="1">Yes — all vessels in this company</option>
          </select>
        </div>
      </div>

      <div v-if="step === 2" class="row">
        <div role="group" class="form-group col-md-12">
          <label class="d-block form-label text-left">
            Role:
          </label>
          <div class="bv-no-focus-ring">
            <v-select
              label="roleName"
              placeholder="Select Role"
              v-model="selectedRoleId"
              :options="roleSelectOptions"
              :reduce="option => option.roleId"
              @search="onSearchRole"
            />
          </div>
        </div>
      </div>

      <div v-if="step === 3" class="row">
        <div v-if="data.uscoAllAssets === '1'" class="col-md-12">
          <p class="text-muted">
            This user has access to all vessels in the company (Access To All Assets = Yes),
            so there's no need to select vessels individually.
          </p>
        </div>
        <div v-else role="group" class="form-group col-md-12">
          <label class="d-block form-label text-left">
            Vessel(s):
          </label>
          <div class="bv-no-focus-ring">
            <v-select
              label="massName"
              placeholder="Select Vessel(s)"
              multiple
              v-model="selectedAssetIds"
              :options="assetSelectOptions"
              :reduce="option => option.massId"
              @search="onSearchAsset"
            />
          </div>
        </div>
      </div>

      <div class="form-group text-right mt-3">
        <b-button
          v-if="step === 1"
          @click="onCancelAddClicked"
          class="mr-1"
          size="sm"
          :disabled="isSubmit"
          variant="outline-danger"
        >
          <div class="mx-2">Cancel</div>
        </b-button>
        <b-button
          v-if="step > 1"
          @click="step -= 1"
          class="mr-1"
          size="sm"
          :disabled="isSubmit"
          variant="outline-secondary"
        >
          <div class="mx-2">Back</div>
        </b-button>
        <b-button
          v-if="step < 3"
          @click="step += 1"
          :disabled="isSubmit || (step === 1 && !step1Valid) || (step === 2 && !step2Valid)"
          variant="primary"
          size="sm"
          class="ml-1"
        >
          <div class="mx-2">Next</div>
        </b-button>
        <b-button
          v-if="step === 3"
          type="submit"
          @click="onSubmitClicked"
          :disabled="isSubmit"
          variant="primary"
          size="sm"
          class="ml-1"
        >
          <div class="mx-2">
            <i v-if="isSubmit" class="ri-loader-line"></i>
            Create User
          </div>
        </b-button>
      </div>
    </div>
  </div>
</template>

<script>
import UserSvc from '@/services/UserSvc';
import AssetSvc from '@/services/AssetSvc';
import requestBuilder from '@/util/request.builder';

const RELATED_FETCH_PAGINATION = { current: 1, pageSize: 100 };

export default {
  name: 'UserForm',
  props: ['data', 'errors', 'isSubmit'],
  data() {
    return {
      step: 1,
      roleOptions: [],
      roleSearchResults: null,
      selectedRoleId: null,
      assetOptions: [],
      assetSearchResults: null,
      selectedAssetIds: [],
    };
  },
  computed: {
    activeCompanyName() {
      const company = this.$store.getters['auth/activeCompany'];
      return company ? company.compName : '-';
    },
    roleSelectOptions() {
      return this.roleSearchResults !== null ? this.roleSearchResults : this.roleOptions;
    },
    assetSelectOptions() {
      return this.assetSearchResults !== null ? this.assetSearchResults : this.assetOptions;
    },
    step1Valid() {
      return !!(this.data.userId && this.data.usloUserName && this.data.usloPassword);
    },
    step2Valid() {
      return !!this.selectedRoleId;
    },
  },
  methods: {
    async fetchRoles() {
      const res = await UserSvc.getRoles({
        params: { ...requestBuilder.buildFilters(RELATED_FETCH_PAGINATION, {}) },
      });
      this.roleOptions = res.data.data;
    },
    async onSearchRole(term) {
      if (!term) {
        this.roleSearchResults = null;
        return;
      }
      const res = await UserSvc.getRoleByName({ findField: 'roleName', findValue: term });
      this.roleSearchResults = res.data.data;
    },
    async fetchAssets() {
      const res = await AssetSvc.getAssets({
        params: { ...requestBuilder.buildFilters(RELATED_FETCH_PAGINATION, {}) },
      });
      this.assetOptions = res.data.data;
    },
    async onSearchAsset(term) {
      if (!term) {
        this.assetSearchResults = null;
        return;
      }
      const res = await AssetSvc.getAssetByName({ findField: 'massName', findValue: term });
      this.assetSearchResults = res.data.data;
    },
    onCancelAddClicked() {
      this.$emit('onCancelAddClicked');
    },
    onSubmitClicked() {
      const payload = {
        ...this.data,
        roleId: this.selectedRoleId,
        assetIds: this.data.uscoAllAssets === '1' ? [] : this.selectedAssetIds,
      };
      this.$emit('onSubmitClicked', payload);
    },
  },
  async mounted() {
    await Promise.all([this.fetchRoles(), this.fetchAssets()]);
  },
};
</script>

<style scoped>

</style>
